var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{attrs:{"src":require("./close.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }